import { TooltipCircle } from "components/tooltipCircle";
import { twMerge } from "tailwind-merge";

interface LabelProps {
    id: string;
    name: string;
    required?: boolean;
    hint?: string;
    className?: string;
    [x:string]: any;
  }
  
export const Label = ({id, name, required, hint, className = "", ...rest}: LabelProps) => {
  return (
    <label htmlFor={id} className={twMerge("w-fit block text-sm font-medium leading-6 mb-2", className)} {...rest}>
      {name} {required ? <span className="text-brand-secondary-500">※</span> : <></>}
      {hint ? <TooltipCircle text={hint} /> : <></>}
    </label>
  )
}
  